import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { routeTree } from "./routeTree.gen";
import { DefaultNotFound, DefaultRouteError } from "./components/RouteFallbacks";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    // Prefetch the next likely route (code-split chunk + loader) as soon as the
    // user hovers/focuses a link, so navigation feels instant.
    defaultPreload: "intent",
    defaultPreloadDelay: 40,
    defaultPreloadStaleTime: 30_000,
    defaultNotFoundComponent: DefaultNotFound,
    defaultErrorComponent: DefaultRouteError,
  });
  setupRouterSsrQueryIntegration({ router, queryClient });

  return router;
};
